import React, {  useState } from "react";
import DeploymentGridTable from "../../../layouts/DeploymentGridTable";


const Deployments = ({setActiveTab}) => {

  return (
    <>
      {/* CRUD Data Grid */}
      <DeploymentGridTable setActiveTab={setActiveTab} />
    </>
  );
};

export default Deployments;
